<template>
    <div v-if="imageUrls === undefined" class="w-full h-full flex items-center justify-center">
        <el-icon class="is-loading">
            <Loading />
        </el-icon>
    </div>

    <el-carousel v-else-if="imageUrls.length > 0" trigger="click"
        :height="height" align="center" :autoplay="false">
        <el-carousel-item v-for="imgUrl in imageUrls" :key="imgUrl">
            <img :src="imgUrl" class="carousel-image" />
        </el-carousel-item>
    </el-carousel>
</template>

<script lang="ts">
import axios from 'axios';
import { ref, onMounted, defineComponent, watch } from 'vue';
import { Loading} from '@element-plus/icons-vue';
import { ResponseStatus } from './response';
import { ElMessage } from 'element-plus';

export default defineComponent({
    name: 'CarouselLoading',
    components: {
        Loading,
    },
    props:{
        modelValue: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: ''
        },
    },
    setup(props) {
        const imageUrls = ref<string[] | undefined>(undefined);

        onMounted(async () => {
            if(!props.modelValue) {
                return;
            }

            const bufImages = props.modelValue.split(',');
            imageUrls.value = await getImages(bufImages);
        });

        watch(() => props.modelValue, async (newValue) => {
            imageUrls.value = undefined;
            
            if(!newValue) {
                return;
            }

            const bufImages = newValue.split(',');
            imageUrls.value = await getImages(bufImages);
        });

        const getImage = async (imageId: string) => {
            var imgUrl = '';
            const res = await axios.get(`/api/images/download/${imageId}`, { responseType: 'blob' });
            if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                // 预览(单张 本画面特定)
                imgUrl = URL.createObjectURL(res.data);
            } else {
                ElMessage.error('画像情報の取得に失敗しました。');
            }

            return imgUrl;
        };

        const getImages = async (imageIds: string[]) => {
            var imgUrls: string[] = [];

            for (const imageId of imageIds) {
                const imgUrl = await getImage(imageId);
                imgUrls.push(imgUrl);
            }

            return imgUrls;
        };
        
        return {
            imageUrls,
        };
    }
});
</script>

<style scoped>
    .carousel-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>